import { Fragment } from "react";
import "./MetaversegameDevelopment.css";
import { metaversegameDevelopment } from "../../staticdata";
import metaversegamebanner from "../../assets/images/services/metaverse/metaversegamebanner.jpg";


const MetaversegameDevelopment = () => {
  return (
    <Fragment>
      <section className="metaversegamedev-style">
        <div className="metaversegamedev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="metaversegamedev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Metaversegame Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Our team of experts is dedicated to crafting immersive
                  experiences that transcend traditional gaming boundaries,
                  allowing you to explore and conquer the dynamic realm of the
                  games metaverse. Through innovative technology and captivating
                  gameplay, we bring your visions to life, ensuring that every
                  adventure within the game metaverse is filled with excitement
                  and boundless potential.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={metaversegamebanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="metaversegamedev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Metaversegame Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {metaversegameDevelopment.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="metaversegamedev-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default MetaversegameDevelopment;
